export const certifications = [
  {
    name: 'CompTIA Cloud Admin Professional - CCAP',
    date: 'Dec 2025',
    issuer: 'CompTIA',
    credlyUrl: 'https://www.credly.com/badges/bb9e99f4-c7aa-40be-813c-31dba2b8b494/public_url',
    pdfUrl: '/certifications/comptia-ccAP.pdf',
    badgeId: 'bb9e99f4-c7aa-40be-813c-31dba2b8b494',
  },
  {
    name: 'CompTIA Secure Cloud Professional - CSCP',
    date: 'Dec 2025',
    issuer: 'CompTIA',
    credlyUrl: 'https://www.credly.com/badges/0a5c2545-7542-4d8c-880d-59a3898fce88/public_url',
    pdfUrl: '/certifications/comptia-csCP.pdf',
    badgeId: '0a5c2545-7542-4d8c-880d-59a3898fce88',
  },
  {
    name: 'CompTIA Cloud+',
    date: 'Dec 2025 - Dec 2028',
    issuer: 'CompTIA',
    credlyUrl: 'https://www.credly.com/badges/b20ff09a-a59b-4881-9ca7-ad31b879ee27/public_url',
    pdfUrl: '/certifications/comptia-cloud-plus.pdf',
    badgeId: 'b20ff09a-a59b-4881-9ca7-ad31b879ee27',
  },
  {
    name: 'CompTIA Network Infrastructure Professional - CNIP',
    date: 'Dec 2025',
    issuer: 'CompTIA',
    credlyUrl: 'https://www.credly.com/badges/fb94fd19-4bf2-4fa4-847b-3ba7b504e2a5/public_url',
    pdfUrl: '/certifications/comptia-cnip.pdf',
    badgeId: 'fb94fd19-4bf2-4fa4-847b-3ba7b504e2a5',
  },
  {
    name: 'CompTIA Server+',
    date: 'Dec 2025 - Dec 2028',
    issuer: 'CompTIA',
    credlyUrl: 'https://www.credly.com/badges/c1055ae4-5f77-44d0-996c-0c56fa6ae5b7/public_url',
    pdfUrl: '/certifications/comptia-server-plus.pdf',
    badgeId: 'c1055ae4-5f77-44d0-996c-0c56fa6ae5b7',
  },
  {
    name: 'CompTIA Security+',
    date: 'Nov 2025 - Nov 2028',
    issuer: 'CompTIA',
    credlyUrl: 'https://www.credly.com/badges/7c7cc031-e68c-4b83-83cb-796ff44a3608/public_url',
    pdfUrl: '/certifications/comptia-security-plus.pdf',
    badgeId: '7c7cc031-e68c-4b83-83cb-796ff44a3608',
  },
  {
    name: 'CompTIA Network+',
    date: 'Oct 2025 - Nov 2028',
    issuer: 'CompTIA',
    credlyUrl: 'https://www.credly.com/badges/c09d368d-548c-4dfe-a94b-28bd6de20caf/public_url',
    pdfUrl: '/certifications/comptia-network-plus.pdf',
    badgeId: 'c09d368d-548c-4dfe-a94b-28bd6de20caf',
  },
];
